import LessonViewer from "../scheduler/LessonViewer";
import Card from "../ui-lib/Card";
import { ViewModeFullWeek } from "../ui-lib/scheduler/viewModeFullWeek";
import { generateComponentSchedule } from "../../helpers/utils/calendar.util";
import { Teacher } from "../../models/teacher/teacher";
import { Vacancy } from "../../models/vacancy/vacancy";
import classNames from "classnames";

type ApplicationCardProps = {
  teacher: Teacher;
  vacancy: Vacancy;
  clicked?: (teacherId: string) => void;
  disabled?: boolean;
};

function ApplicationCard({
  teacher,
  vacancy,
  clicked,
  disabled = false,
  ...props
}: ApplicationCardProps) {
  const onClicked = () => {
    if (clicked && !disabled) {
      clicked(teacher.id);
    }
  };

  return (
    <Card
      className={classNames({
        "flex flex-col": true,
        "duration-300 hover:cursor-pointer hover:shadow-md": !disabled,
      })}
      onClick={onClicked}
    >
      <div className="flex w-full items-center justify-between">
        <span className="font-bold">
          {teacher.name} {teacher.lastname}
        </span>
        <LessonViewer
          lessons={generateComponentSchedule(
            vacancy.schedule,
            new Date(vacancy.startDate),
            new Date(vacancy.endDate),
            vacancy.lessons,
          )}
          startDate={new Date(vacancy.startDate)}
          viewMode={new ViewModeFullWeek(true)}
          teacherId={teacher.id}
        ></LessonViewer>
      </div>
    </Card>
  );
}

export default ApplicationCard;
